import { useEffect, useState } from 'react';

import CountdownTimer from '@klv/molecules/countdown-timer';
import { getEstTimestamp } from './utils/functions';

import * as s from './styles';
import type { ICountdownProps } from './types';

const Countdown = ({
  background,
  headline,
  titleSize,
  countdown,
  customPadding,
  ...props
}: ICountdownProps) => {

  const [hydrated, setHydrated] = useState(false);
  const [displayed, setDisplayed] = useState<boolean>(true);
  const targetDate = getEstTimestamp(countdown);

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) return null;
  
  return (
    <s.StyledCountdown
      background={background}
      {...props}
      displayed={displayed}
      $customPaddingTop={customPadding?.customPaddingTop ?? 'default'}
      $customPaddingBottom={customPadding?.customPaddingBottom ?? 'default'}
    >
      <s.CountdownGrid>
        <s.CountdownContainer>
          {titleSize && headline && <s.CountdownHeadline color={background} forwardedAs="h2" variant={titleSize}>{headline}</s.CountdownHeadline>}
          <CountdownTimer color={background} targetDate={targetDate} setDisplayed={setDisplayed}/>
        </s.CountdownContainer>
      </s.CountdownGrid>
    </s.StyledCountdown>
  );
};

export default Countdown;
